import { createReducer, createTypes } from 'reduxsauce';

export const usuarioTypes = createTypes(
  `
    SAGA_SET_USER
    SET_USER
    SET_ERROR
    SET_FAVORITE_VARS
    SET_PREFERENCES
    SET_INITIALIZE
`,
  { prefix: 'USUARIO/' }
);

const INITIAL_STATE = {
  initialized: false,
  user: null,
  error: '',
  favorites: { vars: [] },
  // Preferencias de UI por usuario (tema e futuras). Blob generico
  // que vem do backend em /user/me e e atualizado via PATCH. Merge
  // raso pra cada SET_PREFERENCES preservar chaves existentes.
  preferences: {},
};

const usuario = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    user: action.user,
    initialized: true,
  };
};

const error = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    error: action.error,
    initialized: true,
  };
};

const favoriteVars = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    favorites: { vars: action.vars || [] },
  };
};

const preferences = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    // Merge raso: preserva chaves ja existentes ao setar uma nova
    // (ex.: setar theme nao apaga outras prefs futuras).
    preferences: { ...state.preferences, ...(action.preferences || {}) },
  };
};

const initialize = (state = INITIAL_STATE) => {
  return {
    ...state,
    initialized: true,
  };
};

export default createReducer(INITIAL_STATE, {
  [usuarioTypes.SET_USER]: usuario,
  [usuarioTypes.SET_ERROR]: error,
  [usuarioTypes.SET_FAVORITE_VARS]: favoriteVars,
  [usuarioTypes.SET_PREFERENCES]: preferences,
  [usuarioTypes.SET_INITIALIZE]: initialize,
});
